var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPositionLIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Property 1=Position L"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 19.8457C10 29.5493 18.489 37.5739 22.2464 40.6504C22.7841 41.0907 23.0562 41.3135 23.4574 41.4265C23.7698 41.5144 24.2296 41.5144 24.542 41.4265C24.9439 41.3133 25.2141 41.0927 25.7539 40.6507C29.5113 37.5742 37.9998 29.5502 37.9998 19.8466C37.9998 16.1744 36.5249 12.6521 33.8994 10.0554C31.2739 7.45879 27.7132 6 24.0002 6C20.2871 6 16.726 7.45901 14.1005 10.0557C11.475 12.6523 10 16.1735 10 19.8457Z",
    stroke: "#333333",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 18C20 20.2091 21.7909 22 24 22C26.2091 22 28 20.2091 28 18C28 15.7909 26.2091 14 24 14C21.7909 14 20 15.7909 20 18Z",
    stroke: "#333333",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPositionLIcon);
export default __webpack_public_path__ + "static/media/PositionLIcon.b43ea0b3ab61fe2559b2ca92c3a19b02.svg";
export { ForwardRef as ReactComponent };